/* Page to fetch all Index Card episodes data and render episode selector
 * Television-only: user must pick an episode before viewing Index Cards.
 */
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { axiosInstance } from "../../api/axiosDefaults";
import { useRedirect } from "../../hooks/Redirect";
import TopBox from "../../components/TopBox";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import EpisodeList from "../episodes/EpisodeList";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Callsheets.module.css";

const IndexCardsPageEpisode = ({ filter = "" }) => {
  useRedirect();
  const history = useHistory();
  const currentUser = useCurrentUser();

  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser.project_category_type)
    : null;

  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    if (projectType && projectType !== "Television") {
      history.replace(
        `/${localStorage.getItem("projectSlug")}/indexcards`
      );
    }
  }, [history, projectType]);

  const fetchEpisodes = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );
      setEpisodes(data.results);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("fetch scene episodes error: ", error);
    }
  };

  useEffect(() => {
    // Only fetch when Television guard passes; avoids unnecessary network calls.
    if (projectType === "Television") {
      fetchEpisodes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectType]);

  const getLink = useCallback((episode) => {
    if (!episode) return "/";
    return `/${localStorage.getItem(
      "projectSlug"
    )}/indexcards?episode=${episode.id}&project=${episode.project}&episodeTitle=${encodeURIComponent(
      episode.episode_number
    )}`;
  }, []);

  return (
    <div>
      <TopBox work="Index Cards" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h3 className="text-center my-3">Select Episode</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`} />
      <EpisodeList
        callEpi={true}
        currentUser={currentUser}
        episodes={episodes}
        getLink={getLink}
      />
    </div>
  );
};

export default IndexCardsPageEpisode;

